import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { DemoDataService } from './demo-data.service';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { FormGroup } from '@angular/forms';
import moment from 'moment';

/**
 * PGI Service - Demo Mode
 * 
 * This service now uses DemoDataService for all PGI/dashboard endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class PGIService {

  public hideTopMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public agencyId: string = '';
  public isWebview: boolean = false;

  public bookoverviewData: any = undefined;
  public targetedOppportunitiesData: any = undefined;
  public productionData: any = undefined;
  public profitablityRetentionData: any = undefined;
  public commissionOverviewData: any = undefined;


  constructor(private http: HttpClient, private requestService: RequestService, private demoDataService: DemoDataService) { }

  resetPagesData() {
    this.profitablityRetentionData = undefined;
    this.bookoverviewData = undefined;
    this.productionData = undefined;
    this.targetedOppportunitiesData = undefined;
    this.commissionOverviewData = undefined;


  }

  /**
   * Get Winback Download List - DEMO MODE
   */
  async GetWinbackDownloadList(month: number): Promise<any> {
    return this.demoDataService.getWinbackDownloadList(month);
  }

  async getPGIOverview(filters: any = {}, getCache: boolean = false, agencyId = this.requestService.currentUser?.mirror_1__1): Promise<void> {
    // console.log(postData);
    if (!agencyId) {
      this.requestService.logout();

    }
    return new Promise((resolve, reject) => {
      if (!this.bookoverviewData || !getCache) {
        let postData: any = {};
        let userID = this.requestService.currentUser?.text7__1;
        let isAgent = this.requestService.isUserAgent();
        // if (postData.agency) {
        //   postData.agency_name = postData.agency;
        // }

        postData.agency = agencyId;
        postData.agency_name = filters.agency_name;
        postData.agent = filters.agent;
        postData.carrier = filters.carrier;
        postData.state = filters.state;
        postData.productline = filters.productline;
        postData.lob = filters.lob;
        postData.userid = isAgent ? userID : undefined;

        if (filters.dateType) {
          if (filters.dateType == 'CUSTOM') {
            postData.dateType = `${moment(filters.startDate).format('yyyyMMDD')}-${moment(filters.endDate).format('yyyyMMDD')}`;
          }
          else {
            postData.dateType = filters.dateType;
          }
        }
        // postData = {
        //   agency: agencyID, // 'y7q56QsPOb98kC_yCtrmXN5DR4_6-z_wH4xqykpxaYY1',
        //   // agency: 'WplIQFgC0iUOXClzDYn6V5BLDABzqHesm7Q7RUZUGpg1',
        //   // lob: 'Homeowners',
        //   // state: 'Colorado',
        //   // productline: 'Personal',
        //   // agent: 'Osmaylin Henriquez',
        //   // carrier: 'Allied',
        //   // test: false,
        // };

        // DEMO MODE: Use DemoDataService instead of postRequest
        this.demoDataService.getPGIOverview(filters, agencyId).then((data) => {
          this.bookoverviewData = data;
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
      }
      else {
        resolve(this.bookoverviewData);
      }
    });
  }



  async getPGIOverviewFilter(agencyName: string = '', lob: any = [], state: any = [], productline: any = [], agent: any = [], carrier: any = []): Promise<void> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let userID = this.requestService.currentUser?.text7__1;
      let isAgent = this.requestService.isUserAgent();
      if (isAgent) {
        agencyName = this.requestService.currentUser?.agency_name;
      }

      let postData: any = {
        agency: agencyID,
        userid: isAgent ? userID : undefined
      };

      if (agencyName) {
        postData.agency_name = agencyName;
      }

      if (lob?.length) {
        postData.lob = lob;
      }

      if (state?.length) {
        postData.state = state;
      }

      if (productline?.length) {
        postData.productline = productline;
      }

      if (agent?.length) {
        postData.agent = agent;
      }

      if (carrier?.length) {
        postData.carrier = carrier;
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getPGIOverviewFilter(agencyName, lob, state, productline, agent, carrier).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  async getTargetedtFilter(agencyName: string = '', lob: any = [], state: any = [], productline: any = [], agent: any = [], carrier: any = [], dimension: string): Promise<void> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let userID = this.requestService.currentUser?.text7__1;
      let isAgent = this.requestService.isUserAgent();
      if (isAgent) {
        agencyName = this.requestService.currentUser?.agency_name;
      }

      let postData: any = {
        agency: agencyID,
        userid: isAgent ? userID : undefined,
        type: 'multiline',
        dimension: dimension,
      };

      if (agencyName) {
        postData.agency_name = agencyName;
      }

      if (lob?.length) {
        postData.lob = lob;
      }

      if (state?.length) {
        postData.state = state;
      }

      if (productline?.length) {
        postData.productline = productline;
      }

      if (agent?.length) {
        postData.agent = agent;
      }

      if (carrier?.length) {
        postData.carrier = carrier;
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getTargetedFilter(agencyName, lob, state, productline, agent, carrier, dimension).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  async getProfitabilityRetentionOverview(filters: any, getCache: boolean = false): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.profitablityRetentionData || !getCache) {
        let agencyID = this.requestService.currentUser?.mirror_1__1;
        let userID = this.requestService.currentUser?.text7__1;
        let isAgent = this.requestService.isUserAgent();
        let postData: any = {
          agency: agencyID,
          userid: isAgent ? userID : undefined
        };

        if (filters?.agency_name && filters?.agency_name != 'All Agencies') {
          postData.agency_name = filters.agency_name;
        }

        // DEMO MODE: Use DemoDataService instead of postRequest
        this.demoDataService.getProfitabilityRetentionOverview(filters).then((data) => {
          this.profitablityRetentionData = data;
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
      }
      else {
        resolve(this.profitablityRetentionData);
      }
    });
  }
  async getCommissionOverview(getCache: boolean = false): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.commissionOverviewData || !getCache) {
        let agencyID = this.requestService.currentUser?.mirror_1__1;
        let postData = {
          agency: agencyID,
        };

        // DEMO MODE: Use DemoDataService instead of postRequest
        this.demoDataService.getCommissionOverview().then((data) => {
          this.commissionOverviewData = JSON.parse(JSON.stringify(data));
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
      }
      else {
        resolve(JSON.parse(JSON.stringify(this.commissionOverviewData)));
      }
    });
  }

  async getPGITargetedOpportunities(getCache: boolean = false): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.targetedOppportunitiesData || !getCache) {
        let agencyID = this.requestService.currentUser?.mirror_1__1;
        let userID = this.requestService.currentUser?.text7__1;
        let isAgent = this.requestService.isUserAgent();
        let postData = {
          agency: agencyID,
          userid: isAgent ? userID : undefined

        };

        // DEMO MODE: Use DemoDataService instead of postRequest
        this.demoDataService.getPGITargetedOpportunities().then((data) => {
          this.targetedOppportunitiesData = data;
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
      }
      else {
        resolve(this.targetedOppportunitiesData);
      }
    });
  }

  async getOpportunitiesDetails(
    pageIndex: number,
    pageSize: number,
    type: string,
    dimension: string,
    sort: Sort, filters?: any
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let userID = this.requestService.currentUser?.text7__1;
      let isAgent = this.requestService.isUserAgent();
      let postData: any = {
        agency: agencyID,
        userid: isAgent ? userID : undefined,
        page_num: pageIndex,
        page_size: pageSize,
        type: type,
        dimension: dimension,
      };

      if (filters) {
        postData.agency_name = filters.agency_name;
        postData.agent = filters.agent;
        postData.carrier = filters.carrier;
        postData.state = filters.state;
        postData.productline = filters.productline;
        postData.lob = filters.lob;
      }

      if (sort) {
        postData.sort_by = sort.active;
        postData.sort_direction = sort.direction.toUpperCase() || 'ASC';
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getOpportunitiesDetails(pageIndex, pageSize, type, dimension, sort, filters).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  // getFilter() {
  //   return this.http.get<any[]>('assets/data/dashboard.json');
  // }

  // getAgencyList() {
  //   return this.http.get<any[]>('assets/data/agencies.json');
  // }
  // getAgentList() {
  //   return this.http.get<any[]>('assets/data/agents.json');
  // }
  // getlobsList() {
  //   return this.http.get<any[]>('assets/data/lobs.json');
  // }
  // getStateList() {
  //   return this.http.get<any[]>('assets/data/states.json');
  // }
  // getProductList() {
  //   return this.http.get<any[]>('assets/data/products.json');
  // }
  // getCarrierList() {
  //   return this.http.get<any[]>('assets/data/carriers.json');
  // }
  getVideoList() {
    return this.http.get<any[]>('assets/data/videos.json');
  }
  // getNotifications() {
  //   return this.http.get<any[]>('assets/data/previousNotifications.json');
  // }
  // getPgi() {
  //   return this.http.get<any[]>('assets/data/pgi.json');
  // }
  // getOpportunities() {
  //   return this.http.get<any[]>('assets/data/opportunitiesDetails.json');
  // }

  async getPGIPoliciesOverviewDetails(pageSize: any = 10, pageNum: any = 0, sort: Sort, selected: any, dataType: string = 'policies', dimension: string = 'sold'): Promise<any> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let userID = this.requestService.currentUser?.text7__1;
      let isAgent = this.requestService.isUserAgent();
      let postData: any = {
        agency: agencyID,
        userid: isAgent ? userID : undefined,
        type: dataType,
        page_num: pageNum,
        page_size: pageSize,
      };

      // Add dimension parameter for quotes type
      if (dataType === 'quotes') {
        postData.dimension = dimension;
      }

      if (selected.city != 'All Cities') {
        postData.city = selected.city;
      }

      if (selected.lob != 'All LOBs') {
        postData.lob = selected.lob;
      }

      if (selected.term != 'All Terms') {
        postData.term = selected.term;
      }

      if (selected.carrier != 'All Carriers') {
        postData.carriername = selected.carrier;
      }

      if (selected.agency != 'All Agencies') {
        postData.agency_name = selected.agency;
      }

      if (selected.productline != 'All Product Lines') {
        postData.productline = selected.productline;
      }

      if (selected.state != 'All States') {
        postData.agencyState = selected.state;
      }

      if (selected.transactionType != 'All Transaction Types') {
        postData.transactiontype = selected.transactionType;
      }

      if (sort) {
        postData.sort_by = sort.active;
        postData.sort_direction = sort.direction.toUpperCase();
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getPGIPoliciesOverviewDetails(pageSize, pageNum, sort, selected, dataType, dimension).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  public getProductionData(getCache: boolean = false): Promise<void> {
    let isAgent = this.requestService.isUserAgent();
    let userID = this.requestService.currentUser?.text7__1;
    return new Promise((resolve, reject) => {
      if (!this.productionData || !getCache) {
        // DEMO MODE: Use DemoDataService instead of postRequest
        this.demoDataService.getProductionData().then((data) => {
          this.productionData = data;
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
      }
      else {
        resolve(this.productionData);
      }
    });
  }

  async getProductionDetails(
    pageIndex: number,
    pageSize: number,
    postData: any,
    sort: Sort
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let userID = this.requestService.currentUser?.text7__1;
      let isAgent = this.requestService.isUserAgent();
      let data: any = {
        agency: agencyID,
        userid: isAgent ? userID : undefined,
        page_num: pageIndex,
        page_size: pageSize,
        ...postData
      };

      if (sort) {
        data.sort_by = sort.active;
        data.sort_direction = sort.direction.toUpperCase() || 'ASC';
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getProductionDetails(pageIndex, pageSize, postData, sort).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getWebviewLink(url): string {
    if (this.isWebview) {
      // console.log(`/mobile${url ? '/' + url : ''}?token=${this.requestService.getToken()}&agencyId=${this.agencyId}`)
      return `/mobile${url ? '/' + url : ''}?token=${this.requestService.getToken()}`;
    }
    else
      return url;
  }

  /**
   * Validate Token - DEMO MODE
   */
  validateToken(token: string): Promise<void> {
    return this.demoDataService.validateToken(token);
  }

  async getProfitabilityFilters(agencyName: string = ''): Promise<void> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let userID = this.requestService.currentUser?.text7__1;
      let isAgent = this.requestService.isUserAgent();
      if (isAgent) {
        agencyName = this.requestService.currentUser?.agency_name;
      }

      let postData: any = {
        agency: agencyID,
        userid: isAgent ? userID : undefined,
      };

      if (agencyName) {
        postData.agency_name = agencyName;
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getProfitabilityFilters(agencyName).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPinnedMessage(channelId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getPinnedMessage(channelId).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  };

  addPinnedMessage(channelId: string, messageId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.addPinnedMessage(channelId, messageId).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  deletePinnedMessage(channelId: string, messageId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.deletePinnedMessage(channelId, messageId).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getUsers(agency: string, productLine: [], carrier: [], state: [], lob: [], agencyId = this.requestService.currentUser?.mirror_1__1): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let postData: any = {};
      postData.agency = agencyId;
      if (agency) {
        postData.agency_name = agency;
      }
      if (productLine?.length) {
        postData.productline = productLine.join(',');
      }
      if (carrier?.length) {
        postData.carrier = carrier.join(',');
      }
      if (state?.length) {
        postData.state = state.join(',');
      }
      if (lob?.length) {
        postData.lob = lob.join(',');
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getUsers(agency, productLine, carrier, state, lob, agencyId).then((users) => {
        resolve(users);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  async getUsersByFilters(role: string = '', states: any = [], accessPoints: any = [], carriers: any = []): Promise<any> {
    return new Promise((resolve, reject) => {
      let agencyID = this.requestService.currentUser?.mirror_1__1;
      let agencyName = this.requestService.currentUser?.agency_name;

      let postData: any = {
        agency: agencyID,
        agency_name: agencyName,
      };

      if (role) {
        postData.role = role;
      }

      if (states?.length) {
        postData.states = states;
      }

      if (carriers?.length) {
        postData.carriers = carriers;
      }

      if (accessPoints?.length) {
        postData.access_type = accessPoints;
      }

      // DEMO MODE: Use DemoDataService instead of postRequest
      this.demoDataService.getUsersByFilters(role, states, accessPoints, carriers).then((data) => {
        resolve(data.results?.users || []);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  getResourcesByTopic(topic: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // DEMO MODE: Use DemoDataService instead of getBusinessResourceByTopic
      this.demoDataService.getResourcesByTopic(topic).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}
